import type { User, UserContext } from '~/models'
import { isProtectasUserIdentity } from '~/utils/brandTranslation'

export const useAuthStore = defineStore(
  'auth',
  () => {
    const currentUser = ref<User | null>(null)
    const authToken = ref<string | null>(null)
    const authError = ref<null | string>('')
    const attemptedPath = ref<string | null>(null)
    const showAdminInterface = ref<boolean>(false)
    const userRoles = ref<string[]>([])
    const userContext = ref<UserContext | null>(null)
    const isProtectasUser = ref<boolean>(false)

    watch(
      currentUser,
      (newUser) => {
        isProtectasUser.value = isProtectasUserIdentity(newUser)
      },
      { immediate: true },
    )

    watch(userContext, (newUserContext) => {
      userRoles.value = newUserContext?.roles.map(role => role.name) ?? []
    })

    return {
      currentUser,
      authToken,
      authError,
      attemptedPath,
      showAdminInterface,
      userContext,
      isProtectasUser,
      userRoles,
    }
  },
  { persist: true },
)
